import React, { useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import db from "./Firebase";
import Moment from "moment";
import { extendMoment } from "moment-range";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function CreateBooking() {
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [startDate, setStartDate] = useState(null); // Start date for range
    const [endDate, setEndDate] = useState(null); // End date for range
    const [loading, setLoading] = useState(false);

    // Function to fetch data based on date range
    const handleSearch = async () => {
        if (!startDate || !endDate) {
            alert("Please select both start and end dates.");
            return;
        }

        setLoading(true);

        try {
            const start = moment(startDate).startOf("day").toDate(); // Start of the day
            const end = moment(endDate).endOf("day").toDate(); // End of the day
            console.log(start)
            console.log(end)

            const q = query(
                collection(db, "nv_create_booking"),
                where("created_date", ">=", start),
                where("created_date", "<=", end)

            );

            const querySnapshot = await getDocs(q);

            const fetchedData = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                data: doc.data(),
            }));

            setData(fetchedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div
                className="p-2"
                style={{
                    paddingBottom: "5px",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <h6>Booking Data</h6>
            </div>

            <div className="p-3">
                {/* Date Range Filter */}
                <div className="mb-3 d-flex align-items-center gap-3">
                    <div>
                        <label>Start Date:</label>
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            className="form-control form-control-sm"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Select Start Date"
                        />
                    </div>
                    <div>
                        <label>End Date:</label>
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            className="form-control form-control-sm"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Select End Date"
                        />
                    </div>
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={handleSearch}
                        style={{ marginTop: "3rem" }}
                    >
                        Search
                    </button>
                </div>

                {/* Table Display */}
                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead
                            className="thead-dark"
                            style={{ position: "sticky", top: "0" }}
                        >
                            <tr>
                                <th>Sr. No</th>
                                <th>Customer Name</th>
                                <th>Customer Phone</th>
                                <th>Business Name</th>
                                <th>Category</th>
                                <th>Services</th>
                                <th>Charges</th>
                                <th>Booking Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        Loading...
                                    </td>
                                </tr>
                            ) : data.length > 0 ? (
                                data.map(({ id, data }, index) => (
                                    <tr key={id}>
                                        <td>{index + 1}</td>
                                        <td>{data.customer_name || "N/A"}</td>
                                        <td>{data.customer_phone || "N/A"}</td>
                                        <td>{data.business_name || "N/A"}</td>
                                        <td>{data.category || "N/A"}</td>
                                        <td>{data.services?.join(", ") || "N/A"}</td>
                                        <td>{data.charges || "0"}</td>
                                        <td>{moment(data.date).format("DD/MM/YYYY")}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        No records found for the selected range.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default CreateBooking;